import GrayHeaderCard from "../../../../../../../../ui/cards/gray-header-card/GrayHeaderCard";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import OfferteBulkTable from "../../bulk-table/OfferteBulkTable";
import {Grid, Tooltip} from "@material-ui/core";
import {Help} from "@material-ui/icons";

const ExtraShareCard = (props) => {
    const cardTitle = <Typography variant="subtitle1">Extra share</Typography>

    return <GrayHeaderCard title={cardTitle}>
        <>
            <Typography variant="subtitle1"
                        className='ml-12'>
                Attivi
            </Typography>

            <OfferteBulkTable
                isClickable
                data={props.attiviTableData}
                loading={props.loading}
            />

            <Grid item
                  className='ml-12 mt-24'
                  xs={12}>
                <Typography variant="subtitle1"
                            display="inline">
                    Da attivare
                </Typography>

                <Tooltip title="Per attivare extra share è necessario contattare il riferimento commerciale"
                         arrow placement="bottom-end">
                    <Help fontSize="small" color="primary"/>
                </Tooltip>
            </Grid>

            <OfferteBulkTable
                isClickable={false}
                data={props.daAttivareTableData}
                loading={props.loading}
            />
        </>
    </GrayHeaderCard>
}

ExtraShareCard.propTypes = {
    attiviTableData: PropTypes.array.isRequired,
    daAttivareTableData: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired
}

export default ExtraShareCard;